import React, { useState, useEffect } from "react";
import {
  ContentLayout,
  ContentLayoutWrapper,
  LayoutWrapper,
  MobileLayoutWrapper,
  MobilePageContent,
  SidebarContainer,
} from "./LayoutStyled";
import PrimarySideBar from "../PrimarySideBar/PrimarySideBar";
import MobileTabBar from "../MobileNav/MobileTabBar";
import AlertBanner from "../AlertBanner/AlertBanner";
import useIsMobile from "../../hooks/useIsMobile";
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../../slice/AuthSlice';

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const user = useSelector(state => state.auth.user);
  const status = useSelector(state => state.auth.status);

  useEffect(() => {
    if (status === 'idle' || !user) {
      dispatch(getCurrentUser());
    }
  }, [dispatch]);

  // Mobile shell (Mobile DMS v1): bottom tab bar instead of the fixed
  // left sidebar, scrollable content padded past the bar. Exactly one
  // of the two shells mounts, so sidebar-owned mount effects (feature
  // flags, unread polling) run once either way — MobileTabBar carries
  // its own copies.
  // The alert banner mounts inside both shells rather than around them
  // so it scrolls with the page content and never overlays the mobile
  // tab bar. It renders nothing when there is nothing to say.
  if (isMobile) {
    return (
      <MobileLayoutWrapper>
        <MobilePageContent>
          <AlertBanner />
          {children}
        </MobilePageContent>
        <MobileTabBar />
      </MobileLayoutWrapper>
    );
  }

  return (
    <LayoutWrapper>
      <ContentLayoutWrapper>
        <SidebarContainer>
          <PrimarySideBar collapsed={collapsed} setCollapsed={setCollapsed} />
        </SidebarContainer>
        <ContentLayout>
          <AlertBanner />
          {children}
        </ContentLayout>
      </ContentLayoutWrapper>
    </LayoutWrapper>
  );
};

export default Layout;

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};